/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Clear_QInputs */



/**
* | output |
* | --- |
* | "Clear the name search" |
*
* @param {Partner_Billing_Board_Clear_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_clear_q = /** @type {((inputs?: Partner_Billing_Board_Clear_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Clear_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Namenssuche zurücksetzen")
	return /** @type {LocalizedString} */ ("Clear the name search")
});